
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import { ModalNext, ModalHeader, ModalBody, ModalFooter } from '@jutro/components';
import cx from 'classnames';

import messages from '../MLSummary.messages'
import styles from '../MLSummary.module.scss'

import { Button } from '@jutro/legacy/components';

function MLTransactionDiffListPopup(props) {
    const {
        transactions,
        diff,
        isOpen,
        onReject
    } = props;
    const translator = useTranslator();
    
    const handleClose = useCallback(() => {
        onReject();
    }, [onReject]);

    if(!isOpen) {
        return null;
    }
    
    const getDateString = (date) => {
        return `${date.month+1}/${date.day}/${date.year}`;
    }

    return (
        <ModalNext
            className={styles['ml-modal-dialog']}
            isOpen={isOpen}
            onRequestClose={handleClose}
            shouldCloseOnOverlayClick={false}
            shouldCloseOnEsc={false}
        >
            <ModalHeader
                title={messages.TransactionDiffListPopupTitle}
                onClose={handleClose}
                contentLayout={{
                    component: 'div',
                    componentProps: {
                        className: styles['modal-header']
                    }
                }}
                titleLayout={{
                    component: 'flex',
                    componentProps: {
                        direction: "column",
                        className: styles['modal-title']
                    }
                }}
            />
            <ModalBody contentLayout={{
                component: 'div',
                componentProps: {
                    className: styles['modal-body']
                }
            }}
            >
                <table className={cx(
                    'table',
                    'table-striped',
                    styles.tableStripedVertical,
                    'table-bordered',
                    styles.tablebordered,
                    'border-top-none',
                    'vertical-spacing-20')}
                >
                    <thead>
                        <tr>
                            <th>&nbsp;</th>
                            {transactions.map((job) => {
                                return (
                                    <th>
                                        {`POLICY EFFECTIVE DATE ${getDateString(job.effDate)}`}
                                    </th>
                                );
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {diff.map((diffItem) => {
                            let nTabs = 0;
                            let thisParentID = diffItem.parentID;
                            while (thisParentID !== 0) {
                                nTabs++;
                                // eslint-disable-next-line no-loop-func
                                thisParentID = diff.find((element) => element.id === thisParentID).parentID;
                            }
                            const cellSpacing = `${50*nTabs}px`;
                            const diffTitleText = <span className={cx(diffItem.isTitle ? 'font-weight-bold' : 'font-weight-normal')}>{`${diffItem.label}`}</span>
                            return (
                                <tr>
                                    <td style={{paddingLeft: (nTabs > 0 ? cellSpacing : '30px')}}>
                                        {diffTitleText}
                                    </td>
                                    <td className="text-align-right">{diffItem.value1}</td>
                                    <td>{diffItem.value2}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </ModalBody>
            <ModalFooter contentLayout={{
                component: 'flex',
                componentProps: {
                    className: styles['modal-footer']
                }
            }}
            >
                <Button id="cancelActionButton" onClick={handleClose} type="outlined" className={styles.pullRight}>
                    { translator(messages.Close) }
                </Button>
            </ModalFooter>
        </ModalNext>
    );

}

MLTransactionDiffListPopup.propTypes = {
    props: PropTypes.shape({
        transactions: PropTypes.shape([]),
        diff: PropTypes.shape([]),
        isOpen: PropTypes.bool,
        onReject: PropTypes.func
    })
};
MLTransactionDiffListPopup.defaultProps = {
    props: {
        isOpen: false
    }
};
export default MLTransactionDiffListPopup;
